"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Directory = void 0;
const core_1 = require("@smash-sdk/core");
const core_2 = require("@smash-sdk/core");
const errors_1 = require("./errors");
__exportStar(require("./errors"), exports);
__exportStar(require("./types/ChangePassword/ChangePassword"), exports);
__exportStar(require("./types/CreateToken/CreateToken"), exports);
__exportStar(require("./types/ForgotPassword/ForgotPassword"), exports);
__exportStar(require("./types/GetSigninConfiguration/GetSigninConfiguration"), exports);
__exportStar(require("./types/ResetPassword/ResetPassword"), exports);
__exportStar(require("./types/SsoSignin/SsoSignin"), exports);
const endpoints = {
    global: "https://directory.fromsmash.co",
};
core_2.config.setHosts("directory", endpoints, false);
class Directory extends core_1.Client {
    constructor(params = {}) {
        super(Object.assign(Object.assign({ service: "directory" }, params), { type: "global", userAgent: "@smash-sdk/directory@1.0.0-alpha.2" }));
        this.errors = errors_1.errors;
    }
    changePassword(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/password/change",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "11-2023",
                    },
                    bodyParameters: {
                        password: params["password"],
                        username: params["username"],
                        account: params["account"],
                        secret: params["secret"],
                        id: params["id"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ChangePasswordError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    createToken(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/token",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "11-2023",
                    },
                    bodyParameters: {
                        username: params["username"],
                        password: params["password"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateTokenError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    forgotPassword(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/password/forgot",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "11-2023",
                    },
                    bodyParameters: {
                        username: params["username"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ForgotPasswordError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    getSigninConfiguration(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/signin/configuration/:username",
                    headers: {},
                    pathParameters: {
                        username: params["username"],
                    },
                    queryParameters: {
                        version: "11-2023",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetSigninConfigurationError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    resetPassword(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/password/reset",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "11-2023",
                    },
                    bodyParameters: {
                        password: params["password"],
                        username: params["username"],
                        account: params["account"],
                        secret: params["secret"],
                        id: params["id"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ResetPasswordError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    ssoSignin(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/sso/signin",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "11-2023",
                    },
                    bodyParameters: {
                        username: params["username"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.SsoSigninError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
}
exports.Directory = Directory;
Directory.errors = errors_1.errors;
